import { render, staticRenderFns } from "./VoucherDetailView.vue?vue&type=template&id=32570e5d&"
import script from "./VoucherDetailView.vue?vue&type=script&lang=js&"
export * from "./VoucherDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports